<template>
  <div class="relative overflow-hidden bg-black">
    <mux-player
      v-if="isPlaying"
      class="absolute inset-0 h-full w-full"
      :playback-id="props.playbackId"
      stream-type="on-demand"
      :autoplay="props.autoplay"
      :metadata-video-title="props.title"
      @playing="onPlaying"
      @timeupdate="onTimeUpdate"
      @ended="onEnded"
    />
    <template v-else>
      <picture>
        <source
          v-if="props.posterWebp"
          :srcset="props.posterWebp"
          type="image/webp"
        />
        <img
          :src="props.poster"
          alt=""
          decoding="async"
          class="absolute inset-0 h-full w-full object-cover"
        />
      </picture>
      <div class="absolute inset-0 bg-black/20" />
      <button
        type="button"
        class="btn btn-yellow absolute top-1/2 left-1/2 h-13 -translate-x-1/2 -translate-y-1/2 gap-x-3 pr-6 pl-4 text-[16px] font-medium whitespace-nowrap md:h-16 md:gap-x-4 md:pr-8 md:pl-6 md:text-[20px] lg:h-20 lg:gap-x-5 lg:pr-10 lg:pl-8 lg:text-[24px]"
        @click="play"
      >
        <span
          class="flex size-8 shrink-0 items-center justify-center rounded-full border-2 border-black md:size-9 lg:size-10"
        >
          <img
            src="/images/icon-play.svg"
            alt=""
            aria-hidden="true"
            class="h-3 w-2.5 md:h-3.5 md:w-3 lg:h-4 lg:w-3.5"
          />
        </span>
        <span>Watch video</span>
      </button>
    </template>
  </div>
</template>

<script setup lang="ts">
interface VideoPlayerProps {
  playbackId: string
  autoplay?: boolean | 'muted' | 'any'
  poster?: string
  posterWebp?: string
  title?: string
}

const props = withDefaults(defineProps<VideoPlayerProps>(), {
  autoplay: 'any',
  poster: '/images/why-wait-video-poster.png',
  title: 'Wait Mate',
})

const isPlaying = ref(false)

// The player (and its HLS engine) only loads once someone presses play, so
// the poster-only first paint costs nothing extra.
const play = async () => {
  await import('@mux/mux-player')
  isPlaying.value = true
}

const { onPlaying, onTimeUpdate, onEnded } = useVideoTracking(() => ({
  title: props.title,
  url: `https://player.mux.com/${props.playbackId}`,
  provider: 'mux',
}))
</script>
